<section id="{{ renderMode }}" class="attach-file-dialog">
  <header class="has-header-text">
    <h1 mat-dialog-title class="has-icon">
      @if (renderMode === 'web-app') {
        <mat-icon fontSet="material-icons-outlined">attach_file</mat-icon>
      }
      <span class="dialog-title-text">Select file to insert into the AwesomeDoc</span>
      <span class="template-name" [innerHTML]="data.templateName" [matTooltip]="data.templateName" matTooltipShowDelay="500"></span>
    </h1>
    <mat-icon
      class="close-dialog"
      [ngClass]="renderMode === 'web-app' ? 'close-dialog-icon' : ''"
      fontIcon="close"
      (click)="onCancelClick()"
      [matTooltip]="'Cancel creating ' + data.templateName + ' AwesomeDoc'"
      matTooltipShowDelay="500"
    >
    </mat-icon>
  </header>
  @if (isDatasourceComponentVisible) {
    <div id="attach-file-accordion-wrapper">
      <mat-accordion class="embedded-expansion-panels">
        @for (data of multiDialogData; track data; let i = $index) {
          @if (data && data.entity.id) {
            <div>
              <app-datasource-attach-file [data]="data" [expand]="i === 0" (fileSelectedChange)="onDatasourceFileSelected($event, i)" />
            </div>
          }
        }
      </mat-accordion>
    </div>
  }
  @if (isDatasourceComponentVisible && isLocalComponentVisible) {
    <div class="or-divider">OR</div>
  }
  @if (isLocalComponentVisible) {
    <app-local-attach-file (fileSelectedChange)="onLocalFileSelected($event)" [entityName]="data.entities[0]?.name" />
  }
  <section mat-dialog-actions class="footer-btns">
    <button
      mat-button
      (click)="onCancelClick()"
      theme-style="nav"
      class="danger-btn-hover"
      [matTooltip]="'Cancel creating ' + data.templateName + ' AwesomeDoc'"
      matTooltipShowDelay="500"
      appRipple
    >
      CANCEL
    </button>
    @if (data.sectionConfig.optional) {
      <button
        mat-button
        (click)="onSkipClick()"
        theme-style="nav"
        [matTooltip]="fileSelected ? 'Continue creating ' + data.templateName + ' AwesomeDoc' : 'Skip file attachment'"
        matTooltipShowDelay="500"
        appRipple
      >
        {{ fileSelected ? 'CONTINUE' : 'SKIP' }}
      </button>
    }
    @if (!data.sectionConfig.optional) {
      <button
        mat-button
        (click)="onOkClick()"
        theme-style="nav"
        [matTooltip]="fileSelected ? 'Continue creating ' + data.templateName + ' AwesomeDoc' : 'Choose a file to continue'"
        matTooltipShowDelay="500"
        [disabled]="!fileSelected"
        appRipple
      >
        CONTINUE
      </button>
    }
  </section>
</section>
